/**
 * LoginStage — ships Variant B (full-bleed photo + glassmorphic card)
 * as the default and only login surface. Variant switcher removed for
 * production.
 *
 * Auth logic / form / OTP step appearance — unchanged.
 */
import VariantFullBleed from './login/VariantFullBleed';

export default function LoginStage({ children }) {
  return <VariantFullBleed>{children}</VariantFullBleed>;
}
